import * as React from 'react';
import { useLocalization } from '@progress/kendo-react-intl';
import kendoka from '../assets/kendoka.png';
import config from '../config/config';

const Info = () => {
    const localizationService = useLocalization();
    const [status, setStatus] = React.useState(null);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        // System-Status vom Backend abrufen
        fetch(`${config.host}/system/status`)
            .then(res => res.json())
            .then(data => {
                setStatus(data);
                setLoading(false);
            })
            .catch(err => {
                console.error('Fehler beim Laden des System-Status:', err);
                setLoading(false);
            });
    }, []);

    const getStatusIcon = (connection) => {
        if (connection === 'ok') return '✓';
        if (connection === 'error') return '✗';
        return '⚠';
    };

    const getStatusColor = (connection) => {
        if (connection === 'ok') return '#4caf50';
        if (connection === 'error') return '#f44336';
        return '#ff9800';
    };

    return (
        <div id="Info" className="info-page main-content">
            <div className="content">
                <div className="kendoka">
                    <img src={kendoka} alt="kendoka" />
                </div>
                
                <div className="section-1">
                    <h1>OMP.media</h1>
                    <h2>Bautagebuch 1.8</h2>
                </div>

                {/* System Status Section */}
                <div className="section-2" style={{ marginTop: '40px' }}>
                    <h2 style={{ marginBottom: '20px' }}>System Status</h2>
                    
                    {loading ? (
                        <p>Lade System-Status...</p>
                    ) : status ? (
                        <div style={{ 
                            fontFamily: 'monospace', 
                            backgroundColor: '#f5f5f5', 
                            padding: '20px', 
                            borderRadius: '8px',
                            lineHeight: '1.8',
                            color: '#ff6600'  // Orange als Standard-Textfarbe
                        }}>
                            {/* Database Status */}
                            <div style={{ marginBottom: '20px' }}>
                                <h3 style={{ 
                                    color: '#ff6600',  // Orange für Überschriften
                                    marginBottom: '10px',
                                    fontWeight: 'bold'
                                }}>
                                    Status
                                </h3>
                                <div style={{ paddingLeft: '20px' }}>
                                    <div>
                                        <span style={{ color: getStatusColor(status.database?.connection) }}>
                                            {getStatusIcon(status.database?.connection)}
                                        </span>
                                        {' '}Firestore Database Connection: 
                                        <strong style={{ color: getStatusColor(status.database?.connection) }}>
                                            {' '}{status.database?.connection || 'unknown'}
                                        </strong>
                                        {status.database?.collections_count !== undefined && (
                                            <span style={{ color: '#666', fontSize: '0.9em' }}>
                                                {' '}({status.database.collections_count} collections)
                                            </span>
                                        )}
                                    </div>
                                    <div>
                                        <span style={{ color: getStatusColor(status.storage?.connection) }}>
                                            {getStatusIcon(status.storage?.connection)}
                                        </span>
                                        {' '}Storage Connection: 
                                        <strong style={{ color: getStatusColor(status.storage?.connection) }}>
                                            {' '}{status.storage?.connection || 'unknown'}
                                        </strong>
                                        {status.storage?.bucket_name && (
                                            <span style={{ color: '#666', fontSize: '0.9em' }}>
                                                {' '}({status.storage.bucket_name})
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Cloud Functions Status */}
                            <div>
                                <h3 style={{ 
                                    color: '#ff6600',  // Orange für Überschriften
                                    marginBottom: '10px',
                                    fontWeight: 'bold'
                                }}>
                                    Cloud Functions
                                </h3>
                                <div style={{ paddingLeft: '20px' }}>
                                    {status.functions?.api && (
                                        <div style={{ marginBottom: '8px' }}>
                                            <span style={{ color: '#4caf50' }}>✓</span>
                                            {' '}<strong style={{ color: '#ff6600' }}>api</strong>: Location = 
                                            <span style={{ color: '#1976d2' }}>
                                                {' '}{status.functions.api.location}
                                            </span>
                                            {' '}({status.functions.api.type})
                                        </div>
                                    )}
                                    {status.functions?.jobStatusTrigger && (
                                        <div style={{ marginBottom: '8px' }}>
                                            <span style={{ color: '#4caf50' }}>✓</span>
                                            {' '}<strong style={{ color: '#ff6600' }}>jobStatusTrigger</strong>: Location = 
                                            <span style={{ color: '#1976d2' }}>
                                                {' '}{status.functions.jobStatusTrigger.location}
                                            </span>
                                            {' '}({status.functions.jobStatusTrigger.type})
                                        </div>
                                    )}
                                    {status.functions?.onJobWrite && (
                                        <div style={{ marginBottom: '8px' }}>
                                            <span style={{ color: '#4caf50' }}>✓</span>
                                            {' '}<strong style={{ color: '#ff6600' }}>onJobWrite</strong>: Location = 
                                            <span style={{ color: '#1976d2' }}>
                                                {' '}{status.functions.onJobWrite.location}
                                            </span>
                                            {' '}({status.functions.onJobWrite.type})
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Timestamp */}
                            {status.timestamp && (
                                <div style={{ 
                                    marginTop: '20px', 
                                    color: '#999', 
                                    fontSize: '0.85em',
                                    borderTop: '1px solid #ddd',
                                    paddingTop: '10px'
                                }}>
                                    Last updated: {new Date(status.timestamp).toLocaleString()}
                                </div>
                            )}
                        </div>
                    ) : (
                        <p style={{ color: '#f44336' }}>Fehler beim Laden des System-Status</p>
                    )}
                </div>
            </div>
            <div className="footer"/>
        </div>
    );
}

export default Info;
